var events = require('./events');

module.exports = function bus(riot) {
  var b = riot.observable();
  b.EVENTS = events;
  return b;
};
